<template>
  <div id="category">
    <div class="navbar section">
      <div class="navbar__aside desktop-only" @click="accordionClicked()">
        <SfHeading :level="3" title="Categories" class="navbar__title" />
      </div>
      <div class="navbar__main"></div>
    </div>
    <div class="main section">
      <div class="sidebar">
        <SfAccordion :first-open="false" :show-chevron="true" :open="$route.query.cat">
          <SfAccordionItem v-for="(accordion, i) in sidebarAccordion" :key="i" :header="accordion.header">
            <template>
              <SfList>
                <SfListItem v-for="(item, j) in accordion.items" :key="j">
                  <SfMenuItem @click="accordionClicked(accordion.header, item.label)" :label="item.label" :count="item.count" />
                </SfListItem>
              </SfList>
            </template>
          </SfAccordionItem>
        </SfAccordion>
      </div>
      <!-- <SfProductCard :title="title" :image="image" :regularPrice="regularPrice" :wishlistIcon="false" /> -->
      <div class="products">
        <transition-group appear name="products__slide" tag="div" class="products__grid">
          <SfProductCard
            v-for="(product, i) in products"
            :key="product.id"
            :style="{ '--index': i }"
            :title="product.title"
            :image="product.image"
            :wishlistIcon="false"
            :regular-price="product.price"
            :special-price="product.priceSpecial"
            :is-on-wishlist="product.isOnWishlist"
            class="products__product-card"
            @click.native="goToProduct(product.ref)"
          />
        </transition-group>
        <SfPagination :current="pageNum" :visible="5" :total="pageTotal" hasArrows @click="changePage" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  SfHeader,
  SfBar,
  SfHeading,
  SfAccordion,
  SfList,
  SfMenuItem,
  SfProductCard,
  SfPagination
} from "@storefront-ui/vue";
import axios from "axios";
export default {
  name: "Category",
  components: {
    SfHeader,
    SfBar,
    SfHeading,
    SfAccordion,
    SfList,
    SfMenuItem,
    SfProductCard,
    SfPagination
  },
  created() {
    this.loadProducts();
  },
  data() {
    return {
      products: [],
      sidebarAccordion: [],
      pageNum: 1,
      pageSize: 20,
      pageTotal: 1
    };
  },
  methods: {
    loadProducts() {
      //{ params: { categoryFilter: this.$route.query.cat, collectionFilter: this.$route.query.coll } }
      axios
        .get("/api/get-products", { params: this.$route.query })
        .then(ret => {
          this.products = ret.data.products;
          this.sidebarAccordion = ret.data.accordion;
          this.pageNum = ret.data.pageNum;
          this.pageTotal = ret.data.pageTotal;
          let getDirs = this.products.map(prod =>
            axios.get("/static/p/" + prod.ref)
          );
          Promise.all(getDirs)
            .then(r => {
              this.products.map((prod, i) => {
                this.products[i].image = r[i].data;
              });
              console.log(this.products);
            })
            .catch(err => {
              console.log(err);
            });
        });
    },
    changePage(page) {
      let newQuery = { ...this.$route.query };
      this.pageNum = page;
      this.$router.push({
        path: "/category",
        query: { ...newQuery, pageNum: page, pageSize: this.pageSize }
      });
      this.loadProducts();
    },
    goToProduct(ref) {
      this.$router.push({ path: "/product/", query: { ref: ref } });
    },
    accordionClicked(cat, coll) {
      let newQuery = { ...this.$route.query };
      if (newQuery.pageNum) {
        newQuery.pageNum = 1;
      }
      delete newQuery.cat;
      delete newQuery.coll;
      if (cat) {
        newQuery.cat = cat;
      }
      if (coll && coll !== "tous") {
        newQuery.coll = coll;
      }
      this.$router
        .push({
          path: "/category",
          query: newQuery
        })
        .catch(err => {
          console.log(err);
        });
      this.loadProducts();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/category.scss";
</style>

<style lang="scss">
.sf-image.sf-product-card__picture.sf-image--has-size {
  background-color: var(--c-white);
}
</style>
